import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TypeToConfirmModal from '../../../components/common/modals/TypeToConfirmModal';
import HoverableTooltip from '../../../components/dataTable/components/HoverableTooltip';
import TrashIcon from '../../../components/icons/TrashIcon';
import useDeleteUser from '../../../hooks/api/users/useDeleteUser';
import { queryClient } from '../../../queryClient';
import { colors } from '../../../styles/variables';
import { QueryAliases } from '../../../types/QueryAliases';

interface DeleteGamerButtonProps {
  id: number;
  gamerName: string;
}

const DeleteGamerButton = ({ id, gamerName }: DeleteGamerButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const { deleteUser, isLoading } = useDeleteUser();

  const handleDeleteGamer = async () => {
    const res = await deleteUser(id);

    if (res.data.deleted) {
      await queryClient.refetchQueries([QueryAliases.ALL_GAMERS]);
      setIsModalOpen(false);
    }
  };

  return (
    <>
      <HoverableTooltip tooltipContent={<p>{t('gamers.deleteGamer.hoverText')}</p>}>
        {isHovered => (
          <button
            className="p-3"
            onClick={e => {
              e.stopPropagation();
              setIsModalOpen(true);
            }}
          >
            <TrashIcon color={isHovered ? colors.red500 : colors.grey700} />
          </button>
        )}
      </HoverableTooltip>
      <TypeToConfirmModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        title={t('gamers.deleteGamer.title')}
        confirmBtnText={t('gamers.deleteGamer.confirmButtonText')}
        confirmBtnAction={handleDeleteGamer}
        cancelBtnText={t('gamers.deleteGamer.cancelButtonText')}
        textToType={gamerName}
        isConfirmBtnDisabled={isLoading}
        isConfirmBtnLoading={isLoading}
      />
    </>
  );
};

export default DeleteGamerButton;
